import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Icon, Button} from '../../common';

export default class KickedPlayerModal extends Component {
  static propTypes = {
    onModalClose: PropTypes.func.isRequired,
    onPlayerKicked: PropTypes.func.isRequired,
    kickRequest: PropTypes.shape({
      kicker: PropTypes.shape({}),
      toKick: PropTypes.shape({}),
    }),
  };

  static defaultProps = {
    kickRequest: {},
  };

  state = {
    hasPlayerAgreed: false,
  };

  onPlayerKickedClicked = () => {
    const {onPlayerKicked, kickRequest: {toKick}} = this.props;

    if (!toKick) {
      return;
    }

    this.setState({hasPlayerAgreed: true});
    onPlayerKicked(toKick.id);
  };

  renderKickModalContent = () => {
    const {kickRequest: {
      toKick: {firstName: toKickFirstName, lastName: toKickLastName},
      kicker: {firstName: kickerFirstName, lastName: kickerLastName},
    }} = this.props;

    return (
      <div>
        <div className="row row_center row_gap_m">
          <Icon glyph="boot"/>
        </div>
        <div className="row row_center">
          <b>{`${kickerFirstName} ${kickerLastName}`}</b>&nbsp;suggests kicking
        </div>
        <div className="row row_center row_gap_m">
          <b>{`${toKickFirstName} ${toKickLastName}`}</b>&nbsp;out of the game.
        </div>
        <div className="row row_center">
          <Button text="I agree, kick the player out" handler={this.onPlayerKickedClicked}/>
        </div>
      </div>
    );
  }

  renderConfirmationContent = () => {
    const {onModalClose} = this.props;

    return (
      <div>
        <div className="row row_column row_center row_gap_m">
          <Icon glyph="boot"/>
          Your vote has been cast!
        </div>
        <div className="row row_center">
          <Button text="Return to game" handler={onModalClose}/>
        </div>
      </div>
    );
  }

  render() {
    const {hasPlayerAgreed} = this.state;

    return (
      <div className="modal__message text-center text-xxx-big text-center">
        {hasPlayerAgreed ? this.renderConfirmationContent() : this.renderKickModalContent()}
      </div>
    );
  }
}
